module.exports = "<div class=\"text-align-center\">\r\n  <h1 class=\"typo-display --margin-xl\">\r\n    Sesión Terminada</h1>\r\n  <div class=\"--margin-lg\">\r\n    Su sesión ha terminado, muchas gracias por utilizar nuestros servicios.\r\n  </div>\r\n  <button class=\"kd-button kd-button--primary --margin-md\"\r\n      type=\"button\"\r\n      ng-click=\"$ctrl.actualizar()\">\r\n    Acceder al sistema\r\n  </button>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/sesion/components/terminada/template.html
// module id = 148
// module chunks = 0